import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetProductTypesList = createSlice({
    name: "getProductTypesList",
    initialState,
    reducers: {
        getProductTypesListRequest(state) {
            state.loading = true;
        },
        getProductTypesListRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getProductTypesListRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getProductTypesListRequest,
    getProductTypesListRequestSuccess,
    getProductTypesListRequestError,
} = GetProductTypesList.actions;

export default GetProductTypesList.reducer;
